<template>
  <div class="slide-section">
    <div>
      <hooper ref="Carousel" :settings="hooperSettings" class="slide-top">
        <slide
          v-for="({ img_desktop, img_mobile }, keyItems) in items"
          :key="keyItems"
          class="item"
        >
          <div class="slide-desktop d-flex align-center" v-if="!xs">
            <img :src="files + img_desktop" />
          </div>
          <div class="slide-mobile d-flex align-center" v-else>
            <img :src="files + img_mobile" />
          </div>
        </slide>
        <hooper-pagination slot="hooper-addons"></hooper-pagination>
      </hooper>
    </div>
  </div>
</template>

<script>
import { Hooper, Slide, Navigation as HooperPagination } from "hooper";
import "hooper/dist/hooper.css";

const _config = {
  mod: "slide-top",
};

export default {
  data: () => ({
    hooperSettings: {
      infiniteScroll: true,
      wheelControl: false,
      autoPlay: true,
      playSpeed: 6000,
      itemsToShow: 1,
      itemsToSlide: 1,
      centerMode: true,
    },
  }),
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    mdAndDown() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    informations() {
      return this.$rest("informations").item;
    },
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  components: { Hooper, Slide, HooperPagination },
};
</script>

<style lang="scss">
.slide-desktop img {
  height: 100%;
  aspect-ratio: 1920/1080 !important;
  object-fit: cover;
}
.slide-top {
  width: 100%;
  height: auto;
  max-height: 100vh;
  aspect-ratio: 1920/1080 !important;
}
@media (max-width: 600px) {
  .slide-top {
    max-height: 600px;
    min-width: 100%;
    aspect-ratio: 600/600 !important;
  }
  .slide-mobile img {
    aspect-ratio: 600/600;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.slide-section ul {
  padding-left: 0 !important;
}
.slide-desktop {
  height: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
}
.slide-desktop img {
  object-position: center top;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.slide-section .hooper-navigation .icon:hover {
  background-color: #2b292a;
}
.slide-section .hooper-navigation .icon {
  transition: all 0.15s;
  fill: #fff;
}
.slide-section .hooper-navigation .icon {
  border-radius: 50%;
  height: 36px;
  width: 36px;
}
.slide-section .hooper-next,
.slide-section .hooper-prev {
  padding: 0 !important;
  outline: none;
}
</style>
